import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  GAMBLING_CONTROL_HOME,
  GAMBLING_CONTROL,
  GAME_CARE_URL,
  PLUS18_URL,
  GAMSTOP_URL,
  BET_BLOCKER,
} from '../../../constants';

import ExternalLink from '../../widgets/ExternalLink';

import styles from './PartnerLogos.module.scss';

const getLogoClasses = (logo) => classNames({
  [styles.icon]: true,
  [styles[`icon--logo-${logo}`]]: true
});

const PartnerLogos = ({ className = '' }) => (
  <div className={`${styles.main} ${className}`}>
    <div className={styles.logos}>
      <ExternalLink href={GAMBLING_CONTROL_HOME} >
        <i className={getLogoClasses('alderney')} />
      </ExternalLink>
      <ExternalLink href={GAMBLING_CONTROL} >
        <i className={getLogoClasses('gambling-commision')} />
      </ExternalLink>
      <ExternalLink href={GAME_CARE_URL} >
        <i className={getLogoClasses('gamcare-problem')} />
      </ExternalLink>
      <ExternalLink href={PLUS18_URL} className={styles['bg-icon--logo-18-plus']}>
        <i className={getLogoClasses('18-plus')} />
      </ExternalLink>
      <ExternalLink href={GAMSTOP_URL}>
        <i className={getLogoClasses('gamstop')} />
      </ExternalLink>
      <ExternalLink href={BET_BLOCKER}>
        <i className={getLogoClasses('bet-blocker')} />
      </ExternalLink>
    </div>
    <span>
      Licensed & Regulated by the Gambling Commision for customers in GB
    </span>
  </div>
);

PartnerLogos.propTypes = {
  className: PropTypes.string
};

export default PartnerLogos;
